import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'
const routes = [
  route('index', '/index', DashboardProfessional, meta('Dashboard profissional', true, 'guest'))
]

export default subGroup('/loading-page', routes)



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/routes.js